import { makeStyles } from '@material-ui/core'

export const useMileageFormStyles = makeStyles(() => ({
  label: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 'var(--vel-fixed-spacing-03)',
    marginBottom: 'var(--vel-fixed-spacing-04)',
    '& > *': {
      margin: 0,
    },
  },
  field: {
    maxWidth: 262,
  },
}))
